import store from '../store'

export default (config) => {
  // Marca a origem: o back não repassa à Holandesa o que vem do site (só o app envia).
  config.headers['X-SCL-Client'] = "web";
  let path = config.url.split('/').pop()
  if (path !== "sign_in") {
    const { access_token } = store.state.login.headers
    config.headers['access-token'] = access_token;
    config.headers['partner'] = "rr.scl";
    return config
  } else {
    return config
  }
}